import { createContextualCan } from '@casl/react';
import AbilityContext from './AbilityContext';
import modules from './modules';

const Can = createContextualCan(AbilityContext.Consumer);

export { AbilityContext, modules };
export default Can;
